<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle d-block">Custos</span>
        <h3 class="page-title d-inline">Editar</h3>
        <d-link class="btn btn-success text-white float-right" :to="{ name: 'admin-cost-new' }">Novo custo</d-link>
        <d-button type="button" @click.prevent="save" class="btn-accent float-right mr-2">Salvar</d-button>
      </d-col>
    </d-row>

    <!-- Content -->
    <d-row>
      <d-col lg="12">
        <cost-page :cost="cost" ref="costForm"/>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import CostPage from '_modules/cost/components/CostPage.vue';
import { MODEL, _LOAD_MODEL_ } from '../components/CostModel';

export default {
  name: 'cost-edit',
  components: {
    CostPage,
  },
  computed: {
    cost() {
      const { cost } = this.$store.state.cost;
      if (cost) {
        Events.$emit(_LOAD_MODEL_, cost);
        return cost;
      }
      return MODEL;
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getCost',
    ]),
    getCostModel() {
      this.getCost(parseInt(this.$route.params.costId, Number));
    },
    save() {
      this.$refs.costForm.save();
    },
  },
  mounted() {
    if (this.$route.params.costId) {
      this.getCostModel();
    }
  },
};
</script>

